import React from 'react'
import Grid from '@mui/material/Grid';
import { Button, Container } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Image1 from '../assets/images/1.jpg';
import Image2 from '../assets/images/2.png';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import ShieldIcon from '@mui/icons-material/Shield';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import 'react-toastify/dist/ReactToastify.css';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Bowl from '../assets/images/bowl.png';
import { Link } from 'react-router-dom';

function Home() {

  return (
    <div>
      <section className='top-home-banner-section'>
        <Container maxWidth="lg">
          <Grid container
            sx={{
              justifyContent: "center",
              alignItems: "center",
            }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <h1 className='b-top-text-1'>Your Trusted Crypto Wallet <span className='b-top-text-1-1'>Unlock the digital world in seconds!</span></h1>
              <p className='b-top-text-2'>Kerdos Wallet supports 100+ blockchains and allows you to connect to thousands of Web3 dApps.</p>
              <div style={{ textAlign: "center" }}>
                <Link to="https://play.google.com/store/apps/details?id=com.kerdos.wallet" target='_blank'><Button  className='b-top-text-btn-1' sx={{ mt: 2 }}>Join Wallet</Button></Link>
              </div>
            </Grid>
          </Grid>
        </Container>
      </section>

      <Container maxWidth="lg" sx={{ pb: 10 }}>
        <LazyLoadImage
          src={Image1}
          alt="Image1"
          style={{ width: '100%', height: 'auto', display: 'block' }}
        />
      </Container>

      <section className='top-home-banner-section-2'>
        <Container maxWidth="lg">
          <h2 style={{ textAlign: "center", color: "#70A2FF", marginBottom: "0px" }}>FEATURES</h2>
          <p className='b-top-text-3'>What makes Kerdos a good choice?</p>
          <Grid container
            className='top-home-banner-section-2-2'
            spacing={4}
            sx={{
              justifyContent: "center",
              alignItems: "center",
            }}>
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <div style={{ textAlign: "center" }}>
                <FingerprintIcon className="b-top-icon-2" />
              </div>
              <Card className="top-home-sec-card-1">
                <CardContent>
                  <h5>Private</h5>
                  <p>We never track personal data, account addresses, or asset balances.</p>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <div style={{ textAlign: "center" }}>
                <ShieldIcon className="b-top-icon-2" />
              </div>
              <Card className="top-home-sec-card-1">
                <CardContent>
                  <h5>Secure </h5>
                  <p>We never collect contact information or personal details and are fully encrypted end-to-end.</p>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <Grid container
            className='top-home-banner-section-2-2'
            spacing={4}
            sx={{
              justifyContent: "center",
              alignItems: "center",
              mt: 1
            }}>
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <div style={{ textAlign: "center" }}>
                <DocumentScannerIcon className="b-top-icon-2" />
              </div>
              <Card className="top-home-sec-card-1">
                <CardContent>
                  <h5>Self-Custody</h5>
                  <p>You're in complete control of your assets—your keys, your crypto.</p>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <div style={{ textAlign: "center" }}>
                <Diversity3Icon className="b-top-icon-2" />
              </div>
              <Card className="top-home-sec-card-1">
                <CardContent>
                  <h5>User-Friendly</h5>
                  <p>Start in minutes with no prior experience required.</p>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </section>

      <section className='top-home-banner-section-3'>
        <Container maxWidth="lg">
          <Grid container
            sx={{
              justifyContent: "center",
              alignItems: "center",
            }}
            spacing={4}
          >
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <LazyLoadImage
                src={Image2}
                alt="Image2"
                style={{ width: '100%', height: 'auto', display: 'block' }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <h5>Introducing a Special Feature: <span>Chatting in Your Crypto Wallet</span></h5>
              <p>Engage with your contacts directly within the app through secure, encrypted messaging. There's no need to share personal contact details; simply use your wallet address to initiate conversations, ensuring you communicate through a private and secure channel.</p>
            </Grid>
          </Grid>
        </Container>
      </section>

      <section className='top-home-banner-section-4'>
        <Container maxWidth="lg">
          <Grid container
            sx={{
              justifyContent: "center",
              alignItems: "center",
            }}
            spacing={4}
          >
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <LazyLoadImage
                src={Bowl}
                alt="image"
              />
              <Card className="top-home-sec-card-1">
                <CardContent>
                  <h5>Manage Your Crypto Assets  <span>with Kerdos</span></h5>
                  <p>Access all your crypto assets in one convenient location with Kerdos. Leverage our secure key vault, robust login features, and digital wallet for effective management of your digital assets. Generate passwords and keys directly on your mobile device to enhance your account security. Effortlessly browse and connect to decentralized websites while maintaining full control over the information you share, allowing you to decide what remains private.</p>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </section>
    </div>
  )
}

export default Home
